import { colors } from "widgets/utils";

import { useGenomeViewerStore } from "../../store/store.ts";
import { drawPhenotypeBullet } from "./phenotypes-renderer.ts";

/**
 * This draw the group header title. Phenotypes, genome name...
 * Always aligned on the left side of the main canvas. Not shifted.
 */
export function drawGroupHeader(label: string, phenotypes: { color: string }[]) {
  const { ctx } = useGenomeViewerStore.getState();
  if (!ctx) return;

  const numBullets = phenotypes.slice(0, 3);
  const bulletSpacing = 9;
  const textPadding = 5;
  const coordinateOffset = 1;
  const clearHeight = 18;

  ctx.save();
  ctx.textAlign = "left";
  ctx.font = "12px Roboto Flex, sans-serif";
  ctx.fillStyle = colors.primaryMain;

  const textWidth = ctx.measureText(label).width;
  const clearWidth = textWidth + textPadding + (textPadding + numBullets.length * bulletSpacing);

  ctx.clearRect(0, 1, clearWidth, clearHeight);

  const centerY = clearHeight / 2;
  const textX = textPadding + numBullets.length * bulletSpacing;
  const textY = centerY + ctx.measureText(label).actualBoundingBoxAscent / 2 - coordinateOffset;

  ctx.fillText(label, textX, Math.ceil(textY + 1));

  numBullets.forEach((phenotype, i) => {
    const bulletX = textPadding + i * bulletSpacing;
    drawPhenotypeBullet(bulletX, centerY, phenotype.color);
  });

  ctx.restore();
}
